import React, { useCallback } from "react"
import { FormControl, FormControlLabel, Box, Checkbox, FormControlLabelProps } from "@material-ui/core"
import { useGa4Context } from "../context/Ga4Context"
import { useStyles } from "../pages/styled"
import theme from "../theme"
import useGa4 from "../hooks/useGa4"

export type CheckBoxFieldProps = Omit<FormControlLabelProps, 'control' | 'className'> & {
}
export const CheckBoxField = (props: CheckBoxFieldProps) => {
  const { onFocus, ...rest } = props

  const classes = useStyles(theme)
  const ga4 = useGa4()
  const ga4Data = useGa4Context().ga4Data
  const handleFocus = useCallback(
    (e: any) => {
      ga4.ga4_formFieldClick({ case_type: ga4Data?.case_type, step: ga4Data?.step, form_name: ga4Data?.form_name, field_name: props.name })
      if (onFocus !== undefined) {
        onFocus(e)
      }
    }, [onFocus, props.name, ga4Data, ga4]
  )
  return (
    <FormControl component="fieldset">
      <Box                         // adjust according to input within TextTield 
        onFocus={handleFocus}
      >
        <FormControlLabel
          className={classes.checkBox}
          control={<Checkbox />}
          {...rest}
        />
      </Box>
    </FormControl>


  )
}


/* 
      {helperText != null && helperText !== '' && (
        <FormHelperText error={error} style={{ marginTop: 0 }}>
          {props.helperText}
        </FormHelperText>
      )} */
